import { render, staticRenderFns } from "./GroupDetailsScreen.vue?vue&type=template&id=1638dcdc"
import script from "./GroupDetailsScreen.vue?vue&type=script&lang=js"
export * from "./GroupDetailsScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports